import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, DatePicker, Switch, Checkbox, Select, Row, Col, Badge, Space, Radio, InputNumber, Typography, Card } from 'antd';

const { Text } = Typography;

import * as recurrence from '../../../../constants/recurrence-constants';

import ChoiceGroup from '../form-wrappers/choice-group';
import ChoiceLine from '../form-wrappers/choice-line';

import ByMonthItem from '../form-items/byMonth-item';
import BySetPositionItem from '../form-items/bySetPosition-item';
import ByDayItem from '../form-items/byDay-item';
import ByMonthDayItem from '../form-items/byMonthDay-item';
import IntervalItem from '../form-items/interval-item';

import ByMonthAndByMonthDayChoise from '../complex-form-choices/by-month-and-by-month-day-choice';
import BySetPositionAndByDayAndByMonthChoice from '../complex-form-choices/by-set-position-and-by-day-and-by-month-choice';

const YearlyGroup = ({ onChangeGroup, requiredItems, selectedChoice, isRadioGroup, rootContainer }) => {
  const complexChoiceSizes = { span: 24, offset: 0, prefix: { span: 4, offset: 0 }, child: { span: 15, offset: 0 }, suffix: { span: 5, offset: 0 } };

  return (
    <ChoiceGroup
      itemObj={{
        isRadioGroup: isRadioGroup,
        onChange: onChangeGroup,
      }}
    >
      <ByMonthAndByMonthDayChoise
        requiredItems={requiredItems}
        selectedChoice={selectedChoice}
        isRadioGroup={isRadioGroup}
        rootContainer={rootContainer}
      />

      <BySetPositionAndByDayAndByMonthChoice
        requiredItems={requiredItems}
        selectedChoice={selectedChoice}
        isRadioGroup={isRadioGroup}
        rootContainer={rootContainer}
      />
    </ChoiceGroup>
  );
};
export default YearlyGroup;
